export default "__VITE_ASSET__BC3eiQIv__"